'use client';

import { Box } from '@mui/material';

export function BrandLogo({ light }: { light?: boolean }) {
  const size = { xs: 112, sm: 132, md: 168 };

  if (light === true) {
    return (
      <Box
        role="img"
        aria-label="TORLIN by HEADSOFT"
        sx={{ position: 'relative', width: size, aspectRatio: '139.48 / 34.581', flexShrink: 0 }}
      >
        <Box
          component="img"
          src="/brand/torlin-logo.svg"
          alt=""
          aria-hidden="true"
          sx={{ position: 'absolute', inset: 0, width: '100%', height: '100%', clipPath: 'inset(0 75.2% 0 0)' }}
        />
        <Box
          component="img"
          src="/brand/torlin-logo.svg"
          alt=""
          aria-hidden="true"
          sx={{ position: 'absolute', inset: 0, width: '100%', height: '100%', clipPath: 'inset(0 0 0 24.8%)', filter: 'brightness(0) invert(1)' }}
        />
      </Box>
    );
  }

  if (light === false) {
    return <Box component="img" src="/brand/torlin-logo.svg" alt="TORLIN by HEADSOFT" sx={{ display: 'block', width: size, height: 'auto' }} />;
  }

  return (
    <Box role="img" aria-label="TORLIN by HEADSOFT" sx={{ position: 'relative', width: size, aspectRatio: '139.48 / 34.581', flexShrink: 0 }}>
      <Box
        component="img"
        src="/brand/torlin-logo.svg"
        alt=""
        aria-hidden="true"
        sx={(theme) => ({ position: 'absolute', inset: 0, width: '100%', height: '100%', ...theme.applyStyles('dark', { display: 'none' }) })}
      />
      <Box sx={(theme) => ({ display: 'none', ...theme.applyStyles('dark', { display: 'block' }) })}>
        <Box component="img" src="/brand/torlin-logo.svg" alt="" aria-hidden="true" sx={{ position: 'absolute', inset: 0, width: '100%', height: '100%', clipPath: 'inset(0 75.2% 0 0)' }} />
        <Box component="img" src="/brand/torlin-logo.svg" alt="" aria-hidden="true" sx={{ position: 'absolute', inset: 0, width: '100%', height: '100%', clipPath: 'inset(0 0 0 24.8%)', filter: 'brightness(0) invert(1)' }} />
      </Box>
    </Box>
  );
}
